const horarioOptions = [
  { value: "Por la mañana", text: "Por la mañana" },
  { value: "Por la tarde", text: "Por la tarde" },
  { value: "Por la noche", text: "Por la noche" },
  { value: "Cualquier horario", text: "Cualquier horario" }
];

const adicionalOptions = [
  {
    option: "a",
    value: "Si",
    defaultChecked: true
  },
  {
    option: "b",
    value: "No (Solo Alarma)",
    defaultChecked: false
  }
];

const alarmaOptions = [
  {
    option: "a",
    value: "Casa",
    accesos: [
      {
        option: "a",
        value: "Por el frente",
      },
      {
        option: "b",
        value: "Por el frente y fondo",
      },
      {
        option: "c",
        value: "Varios accesos",
      },
    ]

  },
  {
    option: "b",
    value: "Depto"
  },
  {
    option: "c",
    value: "Comercio",
  }
];


export { horarioOptions, adicionalOptions, alarmaOptions };
